// src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#D10101",
    },
    secondary: {
      main: "#19857b",
    },
  },
  components: {
    // MuiDrawer: {
    //   styleOverrides: {
    //     paper: {
    //       backgroundColor: "#fff", // Light blue background for the sidebar
    //     },
    //   },
    // },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          //   backgroundColor: "rgba(0,0,0,0.04)", // Slightly darker background for subheaders
          color: "#000", // Dark text color for contrast
          fontSize: "1rem",
          fontWeight: "bolder",
        },
      },
    },
  },
});

export default theme;
